import React from "react";
import AgentTokenConfirm from "../components/AgentTokenConfirm";
export default function AgentConfirmToken() {
  return (
    <>
      <AgentTokenConfirm />
    </>
  );
}
